import React from 'react';

type BottomBarContextType = {
  hasActionBar: boolean;
  setHasActionBar: (v: boolean) => void;
};

const BottomBarContext = React.createContext<BottomBarContextType | undefined>(undefined);

export const BottomBarProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [hasActionBar, setHasActionBar] = React.useState(false);

  return (
    <BottomBarContext.Provider value={{ hasActionBar, setHasActionBar }}>
      {children}
    </BottomBarContext.Provider>
  );
};

export const useBottomBar = () => {
  const ctx = React.useContext(BottomBarContext);
  if (!ctx) {
    throw new Error('useBottomBar must be used within a BottomBarProvider');
  }
  return ctx;
};
